import React, { useEffect } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { FormButtons, FormRow, Map } from '../controls';

function buildDefaultValues(vendor) {
  return {
    description: vendor.description || '',
    vendor: vendor.vendor || {},
    vendorId: vendor.vendor?.vendorId ?? '',
  };
}

export const FestivalVendorForm = ({
  vendor,
  vendors,
  handleSave,
  handleRemove,
  onLocationChange,
}) => {
  const {
    register,
    handleSubmit,
    reset,
    control,
    setValue,
    formState: { errors },
  } = useForm({
    defaultValues: buildDefaultValues(vendor),
    mode: 'onSubmit',
  });

  useEffect(() => {
    reset(buildDefaultValues(vendor));
  }, [vendor, reset]);

  const submit = (vals) => {
    const { vendorId: _id, ...rest } = vals;
    handleSave(rest);
  };

  return (
    <form onSubmit={handleSubmit(submit)}>
      <FormRow label="Vendor" error={errors.vendorId?.message}>
        <Controller
          name="vendorId"
          control={control}
          rules={{ required: 'Vendor is required' }}
          render={({ field }) => (
            <select
              className="h-10 w-full rounded-[20px] border border-[var(--input)] px-4 outline-none"
              value={field.value === '' ? '' : String(field.value)}
              onChange={(e) => {
                const id = e.target.value;
                if (!id) {
                  field.onChange('');
                  setValue('vendor', {});
                  return;
                }
                const found = vendors.find(
                  (x) => String(x.vendorId) === String(id),
                );
                field.onChange(found?.vendorId ?? '');
                setValue('vendor', found || {});
              }}
            >
              <option value="">Select a vendor</option>
              {vendors.map((v) => (
                <option key={v.vendorId} value={String(v.vendorId)}>
                  {v.vendorName}
                </option>
              ))}
            </select>
          )}
        />
      </FormRow>
      <FormRow label="Description">
        <textarea
          placeholder="Festival Specific Vendor Description..."
          {...register('description')}
        />
      </FormRow>
      <FormRow>
        <Map location={vendor.location} handleClick={onLocationChange} />
      </FormRow>
      <FormButtons
        showDelete={vendor.vendorId}
        title="Vendor"
        onDelete={handleRemove}
      />
    </form>
  );
};
